{
  "footer": {
    "text": {
      "imprint": "Thông báo pháp lý",
      "privacy-policy": "Chính sách bảo mật",
      "powered": "Được cung cấp bởi Lumxi GmbH"
    }
  }
}
